import { createContext, useContext } from 'react';
import { GearUiAdminConfigWriteType } from '../../Model/uiAdminConfig/GearUiAdminConfigWriteType';
import { GEAR_UI_ADMIN_CONFIG_TYPE, GearUiAdminConfigType } from '../../Model/uiAdminConfig/GearUiAdminConfigType';
import { GearUiAdminConfigState } from '../../Model/uiAdminConfig/GearUiAdminConfigState';
import { GearHelpCenterState } from '../../Model/GearHelpCenterState';

interface IUiAdminConfigsContext {
  refreshUiAdminConfigState: (configKey: GearUiAdminConfigType) => void;
  setConfigWritePermissionsKeys?: (writeKeys: GearUiAdminConfigType[]) => void;
  isLoading: boolean;
  upsertUiAdminConfigEntry: (key: GearUiAdminConfigType, body: string) => void;
  uiAdminConfigWritePermissions?: GearUiAdminConfigWriteType;
  uiAdminConfigPreviewState: GearUiAdminConfigState;
  setUiAdminConfigPreviewState?: (messageBarPreview: GearUiAdminConfigState) => void;
  resetPreviewState: () => void;
  uiAdminConfigState: GearUiAdminConfigState;
  tempHelpCenterState?: Partial<GearHelpCenterState>;
  setTempHelpCenterState: (tempHelpCenterState: Partial<GearHelpCenterState>) => void;
}

export const UiAdminConfigsContext = createContext<IUiAdminConfigsContext>({
  isLoading: false,
  upsertUiAdminConfigEntry: () => {},
  uiAdminConfigPreviewState: {
    [GEAR_UI_ADMIN_CONFIG_TYPE.MESSAGE_BAR]: undefined,
    [GEAR_UI_ADMIN_CONFIG_TYPE.MAINTENANCE_PAGE]: undefined
  },
  uiAdminConfigState: {},
  resetPreviewState: () => {},
  refreshUiAdminConfigState: () => {},
  setTempHelpCenterState: () => {}
});

export const useUiAdminConfigsContext = () => useContext(UiAdminConfigsContext);
